import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useMemo} from 'react';

export const useSponsoredProductPopup = () => {
  const {isOpen, open, cancel, parameter} =
    useOpenedStateManager(`SPONSORED_PRODUCT`);

  const parameters = useMemo(
    () =>
      JSON.parse(parameter ?? '{}') as {
        productId?: number;
        promotionId?: string;
      },
    [parameter],
  );

  const onSponsoredClick = ({
    e,
    productId,
    promotionId,
  }: {
    e: React.MouseEvent;
    productId?: number;
    promotionId?: string;
  }) => {
    e.preventDefault();
    open({parameter: JSON.stringify({productId, promotionId})});
  };

  return {
    isOpen,
    onSponsoredClick,
    cancel,
    productId: parameters.productId,
    promotionId: parameters.promotionId,
  };
};
